import React from 'react';
import Type from 'prop-types';
import { useAccountData } from 'screens/ProfileScreen/entities/user';
import { HeaderAccount } from './HeaderAccount';
import { HeaderAccountLoading } from './HeaderAccountLoading';

export const HeaderAccountWrapper = (props) => {
  const { onClick } = props;
  const { data: accountData, isLoading: isLoadAccount } = useAccountData();
  if (isLoadAccount) return <HeaderAccountLoading />;

  const fullName = accountData?.name
    ? `${accountData?.name?.first ?? ''} ${accountData?.name?.last ?? ''}`
    : '';
  const userInfo = {
    fullName,
    jobTitle: accountData?.jobTitle ?? '',
  };

  return <HeaderAccount userInfo={userInfo} onClick={onClick} />;
};

HeaderAccountWrapper.propTypes = {
  onClick: Type.func.isRequired,
};
